module.exports = __webpack_public_path__ + "img/arrival_1.d5b5f65d.jpg";